import { render } from "./Orders.vue?vue&type=template&id=1b6a0431&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=1b6a0431&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b6a0431"

export default script